export const getCurrentActions = (actions, videoDuration = null) => {
  /*
   * This logic is needed to keep the original offset and action duration values after
   * the video is trimmed (if the user returns the original duration of the video,
   * the actions will be saved for the original video)
   *
   * Step 1: Sort by offset
   * Step 2: Remove actions that begin after the new video duration value
   * Step 3: If the action starts before the new vieo duration value
   * and ends after - cut the action duration to the new video duration value
   */

  return actions
    ?.sort((a, b) => a.offset - b.offset)
    .filter(({ offset }) => videoDuration ? offset <= videoDuration : true)
    .map(action => {
      if (videoDuration != null) {
        return action.offset + action.duration > videoDuration ? { ...action, duration: videoDuration - action.offset } : action
      } else {
        return action;
      }
    }
    );
};

export const RGBAToHexA = rgba => {
  if (rgba.startsWith('#')) {
    return rgba;
  }

  let startIndex = 4;

  if (rgba.startsWith('rgba')) {
    startIndex = 5;
  }

  let sep = rgba.indexOf(',') > -1 ? ',' : ' ';
  rgba = rgba
    .substr(startIndex)
    .split(')')[0]
    .split(sep);

  for (let R in rgba) {
    let r = rgba[R];
    if (r.indexOf('%') > -1) {
      let p = r.substr(0, r.length - 1) / 100;

      if (R < 3) {
        rgba[R] = Math.round(p * 255);
      } else {
        rgba[R] = p;
      }
    }
  }

  let r = (+rgba[0]).toString(16),
    g = (+rgba[1]).toString(16),
    b = (+rgba[2]).toString(16);

  if (r.length == 1) r = '0' + r;
  if (g.length == 1) g = '0' + g;
  if (b.length == 1) b = '0' + b;

  if (rgba[3]) {
    let a = Math.round(+rgba[3] * 255).toString(16);
    if (a.length == 1) a = '0' + a;

    return '#' + r + g + b + a;
  }

  return '#' + r + g + b;
};

export const getRadiusPerCorner = (callAction) => {
  const perCornerRadius = ['radiusTl', 'radiusTr', 'radiusBr', 'radiusBl'].map(corner => callAction[corner]);
  let useBorderRadius = perCornerRadius.some(corner => corner === null || corner === undefined);
  if (!useBorderRadius) {
    // Check for min corner radius value
    useBorderRadius = callAction.radius > Math.max(...perCornerRadius);
  }
  return [
    useBorderRadius ? callAction.radius : callAction.radiusTl,
    useBorderRadius ? callAction.radius : callAction.radiusTr,
    useBorderRadius ? callAction.radius : callAction.radiusBr,
    useBorderRadius ? callAction.radius : callAction.radiusBl,
  ];
}

export const isHexColor = color => /^#[0-9A-F]{3}|[0-9A-F]{6}[0-9a-f]{0,2}$/i.test(color);
